export const RESOURCE_ACTION_VIEW = 'view'
export const RESOURCE_ACTION_ALL = 'all'
